import { useLocation } from '@solidjs/router';
import { createEffect, on } from 'solid-js';
import { useAuth, useCurrentCompany } from '~/contexts/global';
import { IS_USER_LOGIN_FROM_INTERNAL_KEY } from '~/utils/constant';

export const IntercomInitializer = () => {
  const location = useLocation();
  const { me } = useAuth();
  const { currentCompany } = useCurrentCompany();

  createEffect(
    on(
      () => [me()?.id, currentCompany()?.id, currentCompany()?.name],
      () => {
        if (!me()?.id || sessionStorage.getItem(IS_USER_LOGIN_FROM_INTERNAL_KEY) === 'true') return;
        window.Intercom('boot', {
          api_base: 'https://api-iam.intercom.io',
          app_id: 'yk2iavay',
          user_id: me()?.id,
          company: {
            id: currentCompany()?.id,
            name: currentCompany()?.name,
          },
          name: me()?.name,
          email: me()?.email,
          created_at: me()?.createdAt,
          hide_default_launcher: true,
        });
      }
    )
  );

  createEffect(
    on(
      () => location.pathname,
      () => window.Intercom('update')
    )
  );

  return null;
};
